import { database } from './core';
import { onValue, ref, DataSnapshot } from 'firebase/database';

// Types
export interface WhatsNewMessage {
  id: string;
  title: string;
  description: string;
}

// Database references
const resourceRef = () => ref(database, 'statusQuo');
const whatsNewRef = () => ref(database, `${resourceRef().key}/whatsNew`);

/**
 * Get the current "What's New" message from Firebase
 */
export const getWhatsNew = (callback: (data: any) => void): (() => void) => {
  const unsubscribe = onValue(whatsNewRef(), (snapshot: DataSnapshot) => {
    callback(snapshot.val());
  });
  return unsubscribe;
};

/**
 * Local storage key for hidden message IDs
 */
export const HIDDEN_MESSAGES_STORAGE_KEY = 'marune_hidden_whats_new_messages';